__webpack_require__.p = "/your-pet-project-group1/";